if (typeof TermsAndConditionsToggle !== 'function') {

  class TermsAndConditionsToggle extends HTMLElement {
    constructor() {
      super();

      // Warenkorbseite, Schublade und Popup existieren gleichzeitig im Dokument.
      // Jede Instanz spricht deshalb nur ihren eigenen Knopf an - vorher griff
      // document.querySelector('#CheckOut') immer den erstbesten.
      this.checkbox = this.querySelector('[data-js-terms-checkbox], input[type="checkbox"]');
      this.hint = this.querySelector('[data-js-checkout-hint]');

      if (this.checkbox) {
        this.toggleCheckoutButton();

        this.checkbox.addEventListener('change', () => {
          this.toggleCheckoutButton();
        });
      }
    }

    checkoutButtons() {
      const scope = this.closest('.sidebar__footer, .cart__details, #AjaxCartSubtotal')
        || this.parentElement
        || document;
      const found = [...scope.querySelectorAll('[data-js-checkout-button]')];
      if (found.length) return found;
      // Rueckfall, falls eine App noch die alte ID rendert.
      const legacy = document.getElementById('CheckOut');
      return legacy ? [legacy] : [];
    }

    toggleCheckoutButton() {
      const gesperrt = !this.checkbox.checked;

      this.checkoutButtons().forEach((button) => {
        button.disabled = gesperrt;
        if (gesperrt) {
          button.setAttribute('aria-disabled', 'true');
        } else {
          button.removeAttribute('aria-disabled');
        }
      });

      if (this.hint) {
        this.hint.hidden = !gesperrt;
      }
    }
  }

  if (typeof customElements.get('terms-checkbox') === 'undefined') {
    customElements.define('terms-checkbox', TermsAndConditionsToggle);
  }

}
